import {AllBuildsController} from './all_builds.controller';
import {BuildsPageController} from './builds_page/builds_page.controller';
import buildTabs from './build_tabs/build_tabs.module';


function buildsConfig($stateProvider) {
    $stateProvider
            .state('builds', {
                url: '/builds',
                parent: 'app-layout',
                abstract: true,
                templateUrl: 'states/builds/builds.html'
            })
            .state('builds.all', {
                url: '/',
                templateUrl: 'states/builds/all_builds.html',
                controller: 'AllBuildsController as AllBuilds'
            })
            .state('builds.build_page', {
                url: '/:buildName/:buildNumber/:startTime/:tab/:moduleID',

                params: {
                    startTime: {
                        value: null,
                        squash: true
                    },
                    tab: {
                        value: 'published',
                        squash: true
                    },
                    moduleID: {
                        value: null,
                        squash: true
                    }
                },
                templateUrl: 'states/builds/builds_page/builds_page.html',
                controller: 'BuildsPageController as BuildsPage'
            })
}

export default angular.module('builds', ['buildTabs'])
        .config(buildsConfig)
        .controller('AllBuildsController', AllBuildsController)
        .controller('BuildsPageController', BuildsPageController)



// WEBPACK FOOTER //
// ./states/builds/builds.module.js